export default class JobIndexSalaryModule {
  constructor(element) {
    this.el = element
    this.init()
  }

  init() {
    const module = this.el
    const isDev = window.location.host === 'localhost:1508' ||  window.location.host === '192.168.1.213:1508'

    const {dataset} = module
    const {
      contentsourceid,
      jobsEndpoint,
      resultsEndpoint,
    } = dataset

    const state = {
      numSteps: 2,
      step:  0,
      situationId: null,
      jobTitleId: null,
      salary: null,
      educationId: null,
      jobExperience: null,
      regionId: null,
      age: null,
    }

    console.log('state', state);

    const popupmember = module.querySelector(".popupmember")
    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if(urlParams.has("member")) {
      popupmember.classList.add('hidden')
      if(urlParams.get("member") === '1') {
        state.situationId = 1
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "calculator",
            "content_type": "salary_check",
            "content_name": "member_question_member"
        })
      } else {
        state.situationId = 2
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "calculator",
            "content_type": "salary_check",
            "content_name": "member_question_not_member"
        })
      }
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          "event": "calculator",
          "content_type": "salary_check",
          "content_name": "member_question_shown"
      })
    }

    const steps = [...document.querySelectorAll('[data-step]')]

    const loaderWrapper = module.querySelector('.loader-wrapper')

    const autocomplete = module.querySelector('.autocomplete')
    const autocompleteInput = autocomplete.querySelector('#job-title')
    const autocompleteList = autocomplete.querySelector('[data-autocomplete-list]')
    const autocompleteNoResults = autocomplete.querySelector('.no-results')
    const autocompleteDefaultText = autocomplete.querySelector(".default-box");
    
    const clearInputButtons = [...module.querySelectorAll('.input-frame .clear')]
    clearInputButtons.map(cib => cib.addEventListener('click', onButtonClearInput))
    
    const inputSalary = module.querySelector('input#salary')
    const selectEducation = module.querySelector('#education')
    const inputExperience = module.querySelector('#experience')
    const selectRegion = module.querySelector('#region')

    const salaryCompareIcon = module.querySelector('.salary-icon')

    const educationOptions = [...selectEducation.querySelectorAll('option')]
    const educations = educationOptions.map(option => {
      const {value} = option
      if(!value) return null
      return {id: Number(option.value), label: option.innerText}
    }).filter(r => r)
    
    const regionOptions = [...selectRegion.querySelectorAll('option')]
    const regions = regionOptions.map(option => {
      const {value} = option
      if(!value) return null
      return {id: Number(option.value), label: option.innerText}
    }).filter(r => r)
    
   
    const compare = module.querySelector('[data-compare]')
    const nodeSalaryYour = compare.querySelector('[data-salary-your]')
    const nodeSalaryAvg = compare.querySelector('[data-salary-avg]')
    const nodeSalaryCompare = compare.querySelector('[data-salary-compare]')
    const nodeNumCVs = module.querySelector('.num-cvs')
    const nodeChartNumCVs = module.querySelector('[data-num-cvs]')
    const option_region = module.querySelector(".option-region");
    const option_salary = module.querySelector(".option-salary");
    const option_education = module.querySelector(".option-education");
    const modalHelpText = module.querySelector("#modal-help-text")
    const modalHelpTextClose = modalHelpText.querySelector("[data-button-close]")
    modalHelpTextClose.addEventListener('click', closeModalHelpText)
    const helperTextButton = module.querySelector("#salary-helpbox")
    if (helperTextButton){
      helperTextButton.addEventListener('click', showModalHelpText)
      }
     
     
     const selectGraph = module.querySelector('#select-graph')
     selectGraph.addEventListener('change', onGraphSelectorChange)
     
     
     const nodeChart = module.querySelector('[data-chart]')
     const nodeYaxis = nodeChart.querySelector('.y-axis')
     const nodeXaxis = nodeChart.querySelector('.x-axis')
     const nodeYLabel = module.querySelector('[data-y-label]')
    
    autocompleteInput.addEventListener('focus', onJobTitleFocus)
    autocompleteInput.addEventListener('blur', onJobTitleFocus)
    autocompleteInput.addEventListener('input', onJobTitleInput)
    autocompleteList.addEventListener('click', onAutoButtonClick) 
    
    inputSalary.addEventListener('input', onSaleryChange)
    
    inputSalary.addEventListener('input', onSalaryInput) 
    selectEducation.addEventListener('change', onEducationChange)
    inputExperience.addEventListener('input', onExperienceChange)
    selectRegion.addEventListener('change', onRegionChange)
    
 
    //new
    const stepTwo = steps[1]
    const stepOne = steps[0]
    stepTwo.addEventListener('click', updateZindexStep2)
    stepOne.addEventListener('click', updateZindexStep1)

    inputSalary.addEventListener('input', errorMessage)
    const inputSalaryError = module.querySelector(".salary-error")

    const graph = module.querySelector(".salary-graphs")

    const memberBtn = module.querySelector(".member-btn")
    const notMemberBtn = module.querySelector(".not-member-btn")
    memberBtn.addEventListener('click', popupMember)
    notMemberBtn.addEventListener('click', popupNotMember)

    const resultdiv = module.querySelector(".result-div")
    const noResultDiv = module.querySelector(".no-result-div")
    const resultValueOffer = module.querySelector('[data-value-offer]')
    const valueOffer = module.querySelector(".value-offer")
    
    function onCatch(event){
      const valid1 = autocompleteInput.checkValidity()
      const valid2 = inputSalary.checkValidity()
      if (valid1){
        autocompleteInput.style.borderColor = "#ffffff"
      }else{
        autocompleteInput.style.borderColor = "#eb3838"
      }
      if (valid2){
        inputSalary.style.borderColor = "#ffffff"
      }else{
        inputSalary.style.borderColor = "#eb3838"
      }


    }

    function onSaleryChange(event){
      //validateForm();
    }

    function onGraphSelectorChange(event) {
      const {target} = event
      const {value} = target
      renderGraph(value)
    }

    function renderGraph(type) {
      switch(type) {
        case '0':
          renderGraphSalary()
          break
        case '1':
          renderGraphRegion()
          break
        case '2':
          renderGraphEducation()
          break
        default:
          renderGraphSalary()
      }
    }

    function pushUrlParams(params)
    {
      const query = Object.keys(params).map(key => `${key}=${encodeURI(params[key])}`).join('&');
      const pathQuery = query.length > 0 ? `${window.location.pathname}?${query}` : `${window.location.pathname}`;
      window.history.pushState('', '', pathQuery);
    }

    function getUrlParams() {
      const {search} = window.location
      if(!search.includes('?')) return {}
      let hashes = search.slice(search.indexOf('?') + 1).split('&')
      return hashes.reduce((params, hash) => {
        let [key, val] = hash.split('=')

        // Change Q to term for search
        if(key.toLowerCase() === "q"){
          key = "Term";
        }

        return Object.assign(params, {[key]: decodeURIComponent(val)})
      }, {})
    }


    function renderGraphSalary() {
      const {data} = state
      const {graphResult} = data
      if(!graphResult) return
      nodeYLabel.innerHTML = "Antal cv'er"

      const max = Math.max(...graphResult.map(r => r.yAxis))
      const offset = max > 50? (max > 99 ? 50: 10) : 5;
      const buffer = offset - (max % offset)
      const ceiling = max + buffer
      const numBars = ceiling / offset
      const arr = Array(numBars).fill(null).map((x, i) => ((i + 1) * offset))
      nodeYaxis.innerHTML = arr.map(item => `<div class="bar"><label>${item}</label></div>`).join('')

      nodeXaxis.innerHTML = graphResult.map((item) => {
        const {xAxis, yAxis} = item
        const pct = (yAxis / ceiling) * 100

        return `
          <div class="pillar">
            <label>${xAxis}</label>
            <div class="bar" style="height: ${pct}%"></div>
          </div>
        `
      }).join('')
    }

    function renderGraphRegion() {
      const {regionId, data} = state
      const {graphRegion} = data
      if(!graphRegion) return

      nodeYLabel.innerHTML = 'Løn'

      const max = Math.max(...graphRegion.map(r => r.yAxis))
      const offset = 10000
      const buffer = offset - (max % offset)
      const ceiling = max + buffer
      const numBars = ceiling / offset
      const arr = Array(numBars).fill(null).map((x, i) => ((i + 1) * offset))
      nodeYaxis.innerHTML = arr.map(item => `<div class="bar"><label>${item / 1000}k</label></div>`).join('')

      nodeXaxis.innerHTML = graphRegion.map((item) => {
        const {xAxis, yAxis} = item
        const pct = (yAxis / ceiling) * 100
        const reg = regions.find(e => e.label === item.xAxis)
        const id = reg ? reg.id : null
        const you = regionId === id
        return `
          <div class="pillar ${you ? 'you' : ''}">
            <label>${xAxis}</label>
            <div class="bar" style="height: ${pct}%"></div>
          </div>
        `
      }).join('')
    }

    function renderGraphEducation() {
      const {educationId, data} = state
      const {graphEducation} = data
      if(!graphEducation) return

      nodeYLabel.innerHTML = 'Løn'

      const max = Math.max(...graphEducation.map(r => r.yAxis))
      const offset = 10000
      const buffer = offset - (max % offset)
      const ceiling = max + buffer
      const numBars = ceiling / offset
      const arr = Array(numBars).fill(null).map((x, i) => ((i + 1) * offset))
      nodeYaxis.innerHTML = arr.map(item => `<div class="bar"><label>${item / 1000}k</label></div>`).join('')

      nodeXaxis.innerHTML = graphEducation.map((item) => {
        const {xAxis, yAxis} = item
        const pct = (yAxis / ceiling) * 100
        const edu = educations.find(e => e.label === item.xAxis)
        const id = edu ? edu.id : null
        const you = educationId === id
        return `
          <div class="pillar ${you ? 'you' : ''}">
            <label>${xAxis}</label>
            <div class="bar" style="height: ${pct}%"></div>
          </div>
        `
      }).join('')

      let educationLabels =  nodeXaxis.querySelectorAll('label');
      if (educationLabels){
        educationLabels.forEach(label =>{
          let innerLabel = label.innerHTML
          if (innerLabel.includes('Din uddannelse')){
            label.innerHTML = innerLabel.replace('Din uddannelse', 'udd.')
          }
        });
      }

    }

    function renderRecommended() {
      const {recommended} = state.data
      nodeRecommended.innerHTML = recommended.map(article => {
        const {
          title,
          text,
          linkText,
          linkUrl,
        } = article

        return `
          <div class="column col-sm-12 col-md-4">
          <div class="card blue">
            <div class="article">
              <img class="icon-article" src="/assets/images/icon-article.svg" alt="artikel ikon">
              <div class="content">
                <h3 class="headline-tiny">${title}</h3>
                <p>${text}</p>
                <div class="arrow-link">
                  <img class="" src="/assets/images/arrow.png" alt="pil">
                  <a href="${linkUrl}">${linkText}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        `
      }).join('')
    }

    function loadResults() {
      loaderWrapper.classList.remove('hide')
      clearTimeout(timeout);
      autocompleteList.innerHTML = "";
      const {
        situationId,
        jobTitleId,
        salary,
        educationId,
        jobExperience,
        regionId,
        age,
      } = state

      const options = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          contentSourceId: contentsourceid,
          situationId: situationId,
          jobTitleId: jobTitleId,
          salary: salary,
          educationId: educationId,
          jobExperience: jobExperience,
          regionId: regionId,
          age: null,
        })
      }
      fetch(resultsEndpoint, isDev ? {} : options)
      .then(response => response.json())
      .then(data => {
        state.data = data
        if(data && data.salaryAvg) {
            if (data.graphResult) {
              if (data.graphResult.length < 1) {
                option_salary.style.display = "none";
              } else {
                option_salary.style.display = "block";
              }
            } else {
              option_salary.style.display = "none";
            }

            if (data.graphEducation) {
              if (data.graphEducation.length < 1) {
                option_education.style.display = "none";
              } else {
                option_education.style.display = "block";
              }
            } else {
              option_education.style.display = "none";
            }

            if (data.graphRegion) {
              if (data.graphRegion.length < 1) {
                option_region.style.display = "none";
              } else {
                option_region.style.display = "block";
              }
            } else {
              option_region.style.display = "none";
            }

            

            updateNumCVs()
            renderResultsCompare()
            renderGraph(selectGraph.value)
            graph.classList.remove('hidden')
            updateOfferBanner()
          } else {
            nodeSalaryCompare.innerHTML = ``
            resultdiv.classList.add('hidden')
            noResultDiv.classList.remove('hidden')
          }
          trackresult(state.salary - data.salaryAvg)
          loaderWrapper.classList.add('hide')
        })
        .catch((err) => {
          console.log('error', err)
          loaderWrapper.classList.add('hide')
        })
    }

    function trackresult(diff) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          "event": "calculator",
          "content_type": "salary_check",
          "content_name": "result_diff",
          "numeric_value": diff
      })
    }

    function renderResultsCompare() {
      const {salary} = state
      const {salaryAvg} = state.data

      nodeSalaryYour.innerHTML = thousandSeparator(salary)
      nodeSalaryAvg.innerHTML = thousandSeparator(salaryAvg)

      
      if(salaryAvg > salary) {
        const difference = salaryAvg - salary
        nodeSalaryCompare.innerHTML = `Din løn ligger <span style="color: #f1655d;"> ${thousandSeparator(difference)} kr. </span>under gennemsnittet`
        salaryCompareIcon.src = "/assets/images/red-arrow-down-icon.png"
      } else if(salaryAvg < salary) {
        const difference = salary - salaryAvg
        nodeSalaryCompare.innerHTML = `Din løn ligger <span style="color: #479376;"> ${thousandSeparator(difference)} kr. </span>over gennemsnittet`
        salaryCompareIcon.src = "/assets/images/green-arrow-up-icon.png"
      } else {
        nodeSalaryCompare.innerHTML = `Din løn ligger på gennemsnittet`
        salaryCompareIcon.src = "/assets/images/grey-arrow-right-icon.png"
      }
    }

    function showModalHelpText(){
      modalHelpText.classList.add('show')
    }

    function closeModalHelpText(){
      modalHelpText.classList.remove('show')
    }

    function updateNumCVs() {
      const {numberOfSamples} = state.data

      if(numberOfSamples < 100) {
        nodeNumCVs.innerHTML = 'under 100 CV\'er'
        nodeChartNumCVs.innerHTML = 'under 100 CV\'er'
      } else if(numberOfSamples > 99 && numberOfSamples < 500) {
        nodeNumCVs.innerHTML = 'over 100 CV\'er'
        nodeChartNumCVs.innerHTML = 'over 100 CV\'er'
      } else {
        nodeNumCVs.innerHTML = 'over 500 CV\'er'
        nodeChartNumCVs.innerHTML = 'over 500 CV\'er'
      }
    }

    function updateZindexStep2(direction) {
      if(state.salary !== null && state.jobTitleId !== null) {
        console.log('salary',state.salary)
        console.log('jobid',state.jobTitleId)
        state.step += direction
        stepTwo.classList.add('front')
        stepOne.classList.remove('front')
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "calculator",
            "content_type": "salary_check",
            "content_name": "result_refinement",
            "numeric_value": state.salary
        })
      }
      
    }

    function updateZindexStep1(direction) {
      state.step += direction
      stepOne.classList.add('front')
      stepTwo.classList.remove('front')
    }

    function errorMessage() {
      const regex = /[0-9.]+/
      const errorCheck = regex.test(inputSalary.value)
      if(inputSalary.value !== "" && errorCheck === false) {
        inputSalaryError.classList.add("invalid")
      }
      if(errorCheck === true) { 
        inputSalaryError.classList.remove("invalid")
      }
    }

    function popupMember() {
      state.situationId = 1
      popupmember.classList.add('hidden')
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          "event": "calculator",
          "content_type": "salary_check",
          "content_name": "member_question_member"
      })
    }

    function popupNotMember() {
      state.situationId = 2
      popupmember.classList.add('hidden')
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          "event": "calculator",
          "content_type": "salary_check",
          "content_name": "member_question_not_member"
      })
    }

    function updateOfferBanner() {
      const resultSituations = state.data.resultSituations;
      const existingValueoffers = [...document.querySelectorAll("div.value-offer-new")];

      if (existingValueoffers) {
        existingValueoffers.forEach(offer => {
          offer.remove()
        })
      }

      valueOffer.classList.add('hidden')

      if(resultSituations.length > 1) {
        const height = 100/resultSituations.length
        var count = 0

        resultSituations.map(situation => {
          count++
          if(count === 1) {
            var firstStyle = "value-offer-new-green"
          }
          resultValueOffer.innerHTML += `<div class="value-offer-new ${firstStyle}" style="height: ${height}%;"><div><h1 class="headline">${situation.title}</h1><p class="description">${situation.text}</p><div class="value-btn"><a class="button value-btn-a" href="${state.data.resultSituations[0].linkUrl}">${state.data.resultSituations[0].linkText}</a></div></div></div>`
        })
      } else {
        resultValueOffer.innerHTML += `<div class="value-offer-new-green value-offer-new value-offer-new1"><div><h1 class="headline">${state.data.resultSituations[0].title}</h1><p class="description">${state.data.resultSituations[0].text}</p><div class="value-btn"><a class="button value-btn-a" href="${state.data.resultSituations[0].linkUrl}">${state.data.resultSituations[0].linkText}</a></div></div></div>`
      }
    }


    var timeout = null;

    function onSituationClick(event) {
      const {target} = event
      const {dataset} = target
      const {situationId} = dataset
      state.situationId = situationId

      situationListButtons.forEach(slb => {
        if(target !== slb) {
          slb.classList.remove('active')
        }
        target.classList.add('active')
      })
      buttonNext.disabled = false
      buttonNext.click();
    }

    function onJobTitleFocus(event){
      if (event.type == "focus"){
        if (autocompleteInput.value.length == 0){
          autocompleteDefaultText.style.display = "block";
          autocompleteList.innerHTML = "";
        }
      }
      else{
        autocompleteDefaultText.style.display = "none";
      }
      
    }
    
    function onJobTitleInput(event) {
      const q = event.target.value
      //TODO Der er noget der fejler her validateForm();
      autocompleteNoResults.style.display = 'none'
      if(q.length < 2) return
      
      autocompleteNoResults.style.display = 'none';
      autocompleteDefaultText.style.display = "none";

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const options = {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            query: q
          })
        }
        fetch(jobsEndpoint, isDev ? {} : options)
        .then(response => response.json())
            .then(data => {
              if(data) {
                if(!data || data.length === 0) {
                  autocompleteNoResults.style.display = 'block';
                  autocompleteDefaultText.style.display = 'none';
                  autocompleteList.innerHTML = "";
                } else {
                  autocompleteList.innerHTML = "";
                  autocompleteList.innerHTML = data.map(item => {
                    const {id, title} = item
                    return `
                    <li>
                      <button class="jobTitleItem" data-job-title-id="${id}">${title}</button>
                    </li>
                  `
                  }
                  ).join('')
                }
              }
            })
            .catch((err) => {
              console.log('error', err)
            })

      }, 1500);
    }

    function thousandSeparator(integer) {
      if(!integer) return integer
      return integer.toLocaleString('da-DK').split(',').join('.')
    }

    function onAutoButtonClick(event) {
      const {target} = event
      const {dataset} = target
      const {jobTitleId} = dataset
      autocompleteInput.value = target.textContent
      autocompleteList.innerHTML = ''
      state.jobTitleId = Number(jobTitleId)
      loadResults()
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          "event": "calculator",
          "content_type": "salary_check",
          "content_name": "result",
          "numeric_value": state.salary
      })
    }

    function onSalaryInput(event) {
      const {target} = event
      const {value} = target
      if(!value) return
      const stripped = value.split('.').join('').split(',').join('')
      const salary = Number(stripped)
      if(isNaN(salary)) return
      inputSalary.value = thousandSeparator(salary)
      state.salary = salary
      
      const regex = new RegExp("[0-9]{5,}$");
  
      if(state.jobTitleId != null && regex.test(salary)) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          loadResults()
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              "event": "calculator",
              "content_type": "salary_check",
              "content_name": "result",
              "numeric_value": state.salary
          })
        }, 1500);
        
      }
    }

    var timeout2 = null 

    function onEducationChange(event) {
      const {target} = event
      const {value} = target
      if(!value) {
        state.educationId = null
      } else {
        state.educationId = Number(value)
        // clear
        clearTimeout(timeout2);
        timeout2 = setTimeout(() => {
          loadResults()
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              "event": "calculator",
              "content_type": "salary_check",
              "content_name": "update_education",
              "numeric_value": state.educationId
          })
        }, 1000);
      }
    }

    function onExperienceChange(event) {
      const {target} = event
      const {value} = target
      if(!value || value === '0') {
        state.jobExperience = null
      } else {
        state.jobExperience = Number(value)

        // clear
        clearTimeout(timeout2);
        timeout2 = setTimeout(() => {
          loadResults()
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              "event": "calculator",
              "content_type": "salary_check",
              "content_name": "update_experience",
              "numeric_value": state.jobExperience
          })
        }, 1500);
      }
    }

    function onRegionChange(event) {
      const {target} = event
      const {value} = target
      if(!value) {
        state.regionId = null
      } else {
        state.regionId = Number(value)
        clearTimeout(timeout2);
        timeout2 = setTimeout(() => {
          loadResults()
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              "event": "calculator",
              "content_type": "salary_check",
              "content_name": "update_region",
              "numeric_value": state.regionId
          })
        }, 1000);
      }
    }

    function onAgeInput(event) {
      const {target} = event
      const {value} = target
      const buttonClear = target.parentNode.parentNode.querySelector('.clear')
      if(!value) {
        state.age = null
        buttonClear.style.display = 'none'
      } else {
        const age = Number(value)
        if(isNaN(age)) return
        state.age = Number(value)
        buttonClear.style.display = 'block'
      }
    }

    function onButtonClearInput(event) {
      const {target} = event
      const {parentNode} = target
      let input = parentNode.querySelector('select') || parentNode.querySelector('input')
      const {type} = input
      input.value = type !== 'range' ? '' : 0
      if ('createEvent' in document) {
        const evt = document.createEvent("HTMLEvents")
        evt.initEvent("change", false, true)
        input.dispatchEvent(evt)

        evt.initEvent("input", false, true)
        input.dispatchEvent(evt)

        evt.initEvent("blur", false, true)
        input.dispatchEvent(evt)

      } else {
        input.fireEvent("onchange")
      }
    }
  }
}


  